import { createContext, useContext, useMemo } from 'react'

import { GISSelectionData } from './types'

type GISAutoFillContextType = {
  onGISSelection?: (data: GISSelectionData) => Promise<void>
  isGISAutoFillLoading?: boolean
}

const GISAutoFillContext = createContext<GISAutoFillContextType>({})

type GISAutoFillProviderProps = {
  children: React.ReactNode
  onGISSelection?: (data: GISSelectionData) => Promise<void>
  isGISAutoFillLoading?: boolean
}

export const GISAutoFillProvider = (props: GISAutoFillProviderProps) => {
  const { children, onGISSelection, isGISAutoFillLoading } = props

  const value = useMemo(
    () => ({
      onGISSelection,
      isGISAutoFillLoading,
    }),
    [onGISSelection, isGISAutoFillLoading]
  )

  return <GISAutoFillContext.Provider value={value}>{children}</GISAutoFillContext.Provider>
}

export const useGISAutoFill = () => {
  return useContext(GISAutoFillContext)
}
